import debug from "debug";

class LoggerCtrl {
  private infoLogger = debug("auvious::widget");
  private debugLogger = debug("auvious::widget:debug");
  private errorLogger = debug("auvious::widget:error");

  constructor() {
    this.errorLogger.log = console.error.bind(console);
  }

  public info = this.infoLogger;
  public debug = this.debugLogger;
  public error = this.errorLogger;
}

export const Log = new LoggerCtrl();
